
import {
  Component,
  ElementRef,
  HostListener,
  NgZone,
  OnInit,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { GridConfig } from '../../layout-configs/responsive.interfaces';
import { skipLinksLayoutConfig } from '../../layout-configs/skip-links.layout-config';
import { SlColumnComponent, SlGridComponent } from '@fundacion/components';

@Component({
  selector: 'app-skip-links',
  standalone: true,
  imports: [SlGridComponent, SlColumnComponent],
  templateUrl: './skip-links.component.html',
  styleUrls: ['./skip-links.component.scss'],
})
export class SkipLinksComponent implements OnInit {
  @ViewChildren('menuLink') menuLinks!: QueryList<ElementRef>;
  showMenu = false;
  tabPressed = false;
  config!: GridConfig;

  constructor(private ngZone: NgZone) { }

  menuItems: { label: string; element: string }[] = [
    { label: 'Ir al contenido principal', element: 'main-content' },
    { label: 'Ir a la navegación', element: 'navigation' },
    { label: 'Ir al pie de página', element: 'footer' },
  ];

  ngOnInit(): void {
    this.checkResponsive(window.innerWidth);
  }

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (event.key === 'Tab' && !this.tabPressed) {
      this.tabPressed = true;
      this.showMenu = true;
      setTimeout(() => {
        const firstLink = this.menuLinks.first;
        firstLink?.nativeElement.focus();
      }, 0);
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    const width = (event.target as Window).innerWidth;
    this.checkResponsive(width);
  }

  scrollToElement(id: string): void {
    this.ngZone.runOutsideAngular(() => {
      requestAnimationFrame(() => {
        const element = document.getElementById(id);
        if (element) {
          element.focus({ preventScroll: true });
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  private checkResponsive(width: number): void {
    const isMobile = width <= 769;

    const configMap = {
      mobile: skipLinksLayoutConfig.mobile,
      desktop: skipLinksLayoutConfig.desktop,
    };

    this.config = isMobile ? configMap.mobile : configMap.desktop;
  }
}
